import DataSync from "./DataSync";
import ChangeOwnership from "./ChangeOwnership";
import { useTranslation } from "react-i18next";

const Dashboard: React.FC = () => {
  const [t] = useTranslation("common");

  return (
    <div className="container-lg mx-auto w-full p-6">
      <h1 className="text-3xl font-bold mb-6">{t("dashboard.Dashboard")}</h1>
      
      <div className="mb-8">
        <div className="bg-c-light rounded py-4 pl-6 pr-6">
          <h2 className="text-2xl font-semibold mb-4">{t("dashboard.Data Sync")}</h2>
          <DataSync />
        </div>
      </div>

      <div className="mb-8">
        <div className="bg-c-light rounded py-4 pl-6 pr-6">
          <h2 className="text-2xl font-semibold mb-4">{t("dashboard.ChangeOwnership.Change of ownership")}</h2>
          <ChangeOwnership />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

